//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Category",1,0],[0,"DisplayValue",1,0],[0,"EffectivityTableBuilder",0,"PDM.EffectivityTableBuilder",0],[1,"SelectedObjects",0,"SelectNXObjectList",0],[0,"StringValue",1,0],[0,"Title",1,0]],[[["object"],"Delete",{},1,0],[[],"CreateAttribute",{R_:{changed:''}},0,0],[["objects"],"SetAttributeObjects",{},1,0]],[]];
SPLM.PDM.EffectivityAttributePropertiesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.EffectivityAttributePropertiesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;